<template lang="html">
  <h1 class="logo" v-if="level == 'h1'">
    <span class="logo-line logo-line-1">Big </span>
    <span class="logo-line logo-line-2">Timer</span>
  </h1>
  <h2 class="logo" v-else-if="level == 'h2'">
    <span class="logo-line logo-line-1">Big </span>
    <span class="logo-line logo-line-2">Timer</span>
  </h2>
</template>

<script>
export default {
  name: 'Logo',

  props: {
    level: {
      type: String,
      required: false,
      default: 'h2',
    }
  }
}
</script>

<style lang="scss" scoped>
/* The logo is animated by its parent components */

@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";
@import "../style/abstracts/variables.scss";

.logo{
  display: block;
  text-transform: uppercase;
  text-align: center;
  margin: $medium+rem 0 0 0;
  line-height: 0.7;
}
.logo-line{
  display: block;
}

.logo-line-1{
  font-family: 'Jost*', 'Lato', sans-serif;
  font-weight: 800;
  margin-left: -0.07em;
  font-size: 11.375em;
}
.logo-line-2{
  @include bold-text;
  margin-top: 0.2em;
  margin-left: -0.015em;
  font-size: 6.95em;
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue